<template>
  <div class="content">
    <div style="line-height:80px;width:65px;text-align:center;">
      <i class="el-icon-warning" style="font-size:40px;color:#f5a300;"></i>
    </div>
    <div>
      <p>考试已结束，系统已自动帮您交卷</p>
      <p>
        <span>{{time}}</span>
        秒后自动离开考场
      </p>
    </div>
  </div>
</template>
<script>
export default {
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  data() {
    return {
      time: 10,
      timer: '',
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      if (this.time > 0) {
        this.time--
      } else {
        this.$emit('close')
      }
    }, 1000)
  },
  methods: {

  }
}
</script>
<style scoped>
.content {
  display: flex;
  height: 65px;
}
.content p {
  line-height: 30px;
}
.content p span {
  color: red;
  font-size: 20px;
  font-weight: bold;
}
</style>